import { ApiClient } from '../client.js';
import { DEFAULT_PRODUCT_NAME, GITHUB_USERNAME_PATTERN } from '../constants.js';
import { resolveProfile } from '../profiles.js';
import { emitJson, fail, ok, type Io } from '../output.js';

export async function runProfile(options: {
  github?: string;
  adminUrl?: string;
  json?: boolean;
}): Promise<void> {
  const io: Io = { json: options.json === true, productName: DEFAULT_PRODUCT_NAME };
  if (!options.github) {
    fail(io, 'Nothing to update. Pass --github <username>.', 1, 'NO_FIELDS');
  }
  if (!GITHUB_USERNAME_PATTERN.test(options.github)) {
    fail(
      io,
      `"${options.github}" is not a valid GitHub username (1-39 letters, digits, or hyphens).`,
      1,
      'INVALID_GITHUB_USERNAME',
    );
  }
  const resolved = resolveProfile(options.adminUrl);
  if (!resolved) {
    fail(io, 'Not signed in. Run `ghosty login` first.', 1, 'NOT_LOGGED_IN');
  }
  io.productName = resolved.profile.branding?.productName ?? DEFAULT_PRODUCT_NAME;

  const client = new ApiClient(resolved.adminUrl, resolved.profile.token);
  try {
    const res = await client.post<{ ok: boolean; githubUsername: string }>('/cli/profile', {
      githubUsername: options.github,
    });
    if (io.json) {
      emitJson({ ok: true, githubUsername: res.githubUsername });
      return;
    }
    ok(io, `GitHub username set to ${res.githubUsername}.`);
    ok(io, 'New app repos will grant you push access automatically.');
  } catch (err) {
    fail(io, (err as Error).message, 1, 'API_ERROR');
  }
}
